module.exports = __webpack_public_path__ + "img/hr-level2addon_running_gun_shadow.99f553c5.png";